import { Injectable } from '@angular/core';
import { AppSettings } from '../../../../../app.settings';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailauditService {
 // Base_url = 'http://mtrx-svr928.matrix.local/api/';
  Base_url = `${AppSettings.EMAIL_API_ENDPOINT}`;
 emailDataUrl = this.Base_url+`/${'emails'}`;
  emailQAScoreUrl = this.Base_url+`/${'email'}`;
  emailTranscriptUrl = this.Base_url+`/${'get-email-text'}`;
  deleteEmailTableUrl = this.Base_url+`/${'email'}`;
  updateManualScoreUrl = this.Base_url+`/${'email/update_manual_score'}`;
  mailsendUrl =    this.Base_url+`/${'email/sendmail'}`;
  constructor(private http: HttpClient) { }

  getEmailData(payload:any){
   return this.http.post(this.emailDataUrl,payload);
  }

  getTranscriptData(id: string){
    return this.http.get(`${this.emailTranscriptUrl}/${id}`);
  }

  deleteEmailData(id:string){
    return this.http.delete(`${this.deleteEmailTableUrl}/${id}`);
  }

  getQAScoreEmail(id:string){
    return this.http.get(`${this.emailQAScoreUrl}/${id}`);
  }

  // getEmailDeleteData(value) {
  //   return this.http.get(`${this.logUrl}/remove-email-byid/${value}`);
  // }

  updateManualScore(payload:any){
    return this.http.post(`${this.updateManualScoreUrl}`,payload);
  }

  sendMailReply(payload:any){
    return this.http.post(this.mailsendUrl,payload);
  }



}
